import HttpService from "../../constant/Api";
import { Log, logType } from "../../constant/helper";

const API = "v1/support";
const API_V2 = "v2/support";

export const getSubscriberTicketsService = (
  params = {
    subject: "",
    pageNumber: 0,
    pageSize: 1000,
    sort: "ASC",
  }
) => {
  return HttpService.get(`${API}/tickets/get-user-tickets`, { params });
};

export const getSupportCategoriesService = (
  params = {
    pageNumber: 0,
    pageSize: 1000,
    sort: "ASC",
  }
) => {
  return HttpService.get(`${API}/categories`, { params });
};

export const getSupportListService = (
  ticketId,
  params = {
    pageNumber: 0,
    pageSize: 1000,
    sort: "ASC",
  }
) => {
  return HttpService.get(`${API}/ticket-messages/ticket/${ticketId}`, {
    params,
  });
};

export const getSupportListServiceVersion2 = (
  ticketId,
  params = {
    pageNumber: 0,
    pageSize: 1000,
    sort: "ASC",
  }
) => {
  return HttpService.get(`${API_V2}/messages/ticket/${ticketId}`, {
    params,
  });
};

export const getSupportTicketService = (ticketId) => {
  return HttpService.get(`${API}/tickets/${ticketId}`);
};

export const sendMessageService = (data) => {
  return HttpService.post(`${API}/ticket-messages`, data);
};

export const sendMessageServiceVersion2 = (data, ticketId) => {
  return HttpService.post(`${API_V2}/messages/${ticketId}`, data);
};

export const createTicketService = (data) => {
  return HttpService.post(`${API}/tickets`, data);
};

export const rateToSupportService = (
  params = { ticketId: "", comment: "", rate: 0 }
) => {
  if (!params.ticketId || !params.ticketId.length) {
    Log("ticketId is not found", logType.error);
    return false;
  }

  return HttpService.post(`${API}/tickets/ratings`, params);
};
